/**************************************************
 * Nombre:       BotonWhatsApp
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {IconButton} from "@mui/material";
import {WhatsApp} from '@mui/icons-material'
import {iniciarChatWhatsApp} from "../../Utilidades/iniciarChatWhatsApp";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const BotonWhatsApp = ({numero}) => {
    const {sCell} = useResponsive()

    return (
        <IconButton
            onClick={() => iniciarChatWhatsApp({numero: numero})}
            color={'action'}

            variant={'outlined'}
            sx={{borderRadius: 8, px: sCell ? 1 : 4, pt: 1, pb: 0.8, color: '#000', fontSize: 18}}
        >
            <WhatsApp sx={{fill: '#000', height: 40, width: 40}}/>

        </IconButton>
    )

}
export default BotonWhatsApp